module.exports = __webpack_public_path__ + "img/background036.jpg";